import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import OrderServices from "../../../services/OrderingServices/OrderServices";

const StatusUpdateModal = ({
  isOpen,
  toggle,
  orderDetailId,
  fetchOrderList,
  currentStatus,
  refreshOrderData,
}) => {
  console.log("🚀 ~ orderDetailId:", orderDetailId)
  // const statusOptions = [
  //   { value: 1, label: "Ongoing" },
  //   { value: 2, label: "Received" },
  //   { value: 3, label: "Processing" },
  //   { value: 4, label: "Ready" },
  //   { value: 5, label: "Delivering" },
  //   { value: 6, label: "Cancelled" },
  //   { value: 7, label: "Completed" },
  // ];
  const statusOptions = [
    { value: 1, label: "Ongoing" },
    { value: 2, label: "Completed" },
    { value: 3, label: "Cancelled" },
  ];

  // Helper function to map status label to numeric value
  const getStatusValueFromLabel = (label) => {
    const option = statusOptions.find((opt) => opt.label === label);
    return option ? option.value : ""; // Return empty string if no match
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      status: currentStatus ? getStatusValueFromLabel(currentStatus) : "",
      remarks: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      status: Yup.number().required("Status is required"),
      remarks: Yup.string().max(500, "Remarks must be 500 characters or less"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await OrderServices.updateStatus(
          orderDetailId,
          values.status, // Now sending the numeric value
       
        );
        toast.success("Status updated successfully", { autoClose: 3000 });
        await fetchOrderList();
        // Call refreshOrderData if it exists
        if (refreshOrderData) {
          refreshOrderData();
        }
        resetForm();
        toggle();
      } catch (error) {
        toast.error("Failed to update status");
        console.error("Error updating status:", error);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Order Status</ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="statusSelect">Status</Label>
            <Input
              type="select"
              name="status"
              id="statusSelect"
              value={formik.values.status}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.status && !!formik.errors.status}
            >
              <option value="">Select Status</option>
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
            {formik.touched.status && formik.errors.status && (
              <div className="invalid-feedback">{formik.errors.status}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="remarks">Remarks</Label>
            <Input
              type="textarea"
              name="remarks"
              id="remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter any remarks (optional)"
              invalid={formik.touched.remarks && !!formik.errors.remarks}
            />
            {formik.touched.remarks && formik.errors.remarks && (
              <div className="invalid-feedback">{formik.errors.remarks}</div>
            )}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={formik.handleSubmit}
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Updating..." : "Update Status"}
        </Button>{" "}
        <Button
          color="danger"
          onClick={() => {
            formik.resetForm();
            toggle();
          }}
          disabled={formik.isSubmitting}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StatusUpdateModal;
